import PDF1 from '../../../assets/document/Company_profile_Fincantieri_Si_eng.pdf';
import PDF2 from '../../../assets/document/fincantieri_si_modello_231_parte_generale_ita.pdf';
import PDF3 from '../../../assets/document/codice_comportamento_condotta_Fincantieri_SI_Ita.pdf';
import PDF4 from '../../../assets/document/sistema_di_segnalazioni_fcsi_whistleblowing_ITA.pdf';
import PDF5 from '../../../assets/document/condizioni_generali_di_acquisto_Fincantieri_si_ITA.pdf';
import PDF6 from '../../../assets/document/condizioni_generali_di_appalto_fincantieri_si_ita.pdf';
import PDF7 from '../../../assets/document/Company_profile_Fincantieri_Si_eng.pdf';
import PDF8 from '../../../assets/document/general_si_contract_conditions_Fincantieri_si_ENG.pdf';
import PDF9 from '../../../assets/document/general_si_purchasing_conditions_Fincantieri_SI_ENG.pdf';
import PDF10 from '../../../assets/document/CONDIZIONI GENERALI D’APPALTO SI PER FORNITURE, LAVORI E SERVIZI A TERRA.pdf';
import PDF11 from '../../../assets/document/Politica Qualità FCSI.pdf';

import IMG1 from '../../../assets/img/media/Companyprofile.png';
import IMG2 from '../../../assets/img/media/Modello231.png';
import IMG3 from '../../../assets/img/media/Codicedicomportamento.png';
import IMG4 from '../../../assets/img/media/Sistemadisegnalazioni.png';
import IMG5 from '../../../assets/img/media/Condizionigeneralidiacquisto.png';
import IMG6 from '../../../assets/img/media/Condizionigeneralidiappalto.png';

export const dataMedia = [
  {
    image: IMG1,
    titleIT: 'Company Profile',
    titleEN: 'Company Profile',
    urlIT: PDF1,
    urlEN: PDF7,
  },
  {
    image: IMG2,
    title: 'MODELLO 231 PARTE GENERALE ',
    urlIT: PDF2,
  },
  {
    image: IMG3,
    title: 'CODICE DI COMPORTAMENTO',
    urlIT: PDF3,
  },
  {
    image: IMG4,
    title: `SISTEMA DI SEGNALAZIONI ALL'ORGANISMO DI VIGILANZA`,
    urlIT: PDF4,
  },
  {
    image: IMG5,
    titleIT: 'Condizioni Generali di Acquisto',
    titleEN: 'GENERAL SI PURCHASING CONDITIONS',
    urlIT: PDF5,
    urlEN: PDF9,
  },
  {
    image: IMG6,
    titleIT: 'Condizioni Generali di Appalto',
    titleEN: 'GENERAL SI CONTRACT CONDITIONS',
    urlIT: PDF6,
    urlEN: PDF8,
  },
  {
    image: '',
    titleIT:
      'CONDIZIONI GENERALI D’APPALTO SI PER FORNITURE, LAVORI E SERVIZI A TERRA',
    titleEN:
      'CONDIZIONI GENERALI D’APPALTO SI PER FORNITURE, LAVORI E SERVIZI A TERRA',
    urlIT: PDF10,
    urlEN: PDF10,
  },
  {
    image: '',
    titleIT: 'POLITICA QUALITÀ FCSI',
    titleEN: 'POLITICA QUALITÀ FCSI',
    urlIT: PDF11,
    urlEN: PDF11,
  },
];
